import APIPlan from "@/api/plan"
import { Benifit } from "@/models/ICommon"
import stores from "@/stores"
import { openCustomURL } from "@/utils/location"
import toast from "@/utils/toast"

import UpgradePannel from "./content/UpgradePannel"

export function showUpgradeModal(props: {
  // 1 月付 2 年付
  type: number
  // 1 免费   2Essential   3Professional   4Enterprise
  package_kind: number
  pricingId?: number
  bannerText?: string
  feature: Benifit | "run_out_of_quota"
}) {
  window.track("upgrade_popup_show", {
    source: props.feature,
  })
  const map2 = {
    "2": "essential",
    "3": "professional",
    "4": "enterprise",
  }
  window.cwreport?.report("click_upgrade", {
    plan_version: map2[props.package_kind] ?? "essential",
    upgrade_position: props.feature ?? "",
  })
  if (stores.PlanStore.config?.user_pkg?.source === 3) {
    stores.PlanStore.setAppType("bundle")
    stores.PlanStore.setPerferKind(props.package_kind)
    pnav("/billing", {
      tab: "bundle",
      kind: props.package_kind,
    })
    return
  }
  const { type, package_kind, pricingId, bannerText } = props
  if (pricingId) {
    const info = stores.PlanStore.getInfoByPricingId(
      package_kind,
      type,
      pricingId,
    )
    stores.PlanStore.setStepOfUpgrade(info?.step ?? 0)
  } else {
    stores.PlanStore.setStepOfUpgrade(0)
  }
  const map = {
    "2": t("UpgradeToEssentialPlan"),
    "4": t("UpgradeToEnterprisePlan"),
    "3": t("UpgradeToProfessionalPlan"),
  }
  stores.CommonStore.setConfirmModalConfig({
    title: map[package_kind] ?? t("UpgradePlan"),
    message: (
      <UpgradePannel
        type={type}
        package_kind={package_kind}
        bannerText={bannerText}
      />
    ),
    onConfirm: async () => {
      const value = stores.PlanStore.getInfoByStep(
        package_kind,
        type,
        stores.PlanStore.stepOfUpgrade,
      )
      // api调用处理
      const packageId = value?.current.id
      if (!packageId) {
        toast(t("OperationFailed"), 4e3, true)
        return false
      }
      // 升级套餐
      const res = await APIPlan.createStorePaidSubscribe(packageId, 3)
      const confirmationUrl = res?.data?.confirmation_url
      // 请求成功
      if (res.code === 1000 && confirmationUrl) {
        openCustomURL(confirmationUrl, false)
      } else {
        return false
      }
    },
  })
}
